import { createSvgIcon } from "@mui/material";

const ExpandFirstLevelIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="currentColor">
    <path d="M3.90033 16.667C3.442 16.667 3.04964 16.5038 2.72325 16.1774C2.39686 15.851 2.23367 15.4587 2.23367 15.0003V3.33366C2.23367 2.87533 2.39686 2.48296 2.72325 2.15658C3.04964 1.83019 3.442 1.66699 3.90033 1.66699H15.567C16.0253 1.66699 16.4177 1.83019 16.7441 2.15658C17.0705 2.48296 17.2337 2.87533 17.2337 3.33366V15.0003C17.2337 15.4587 17.0705 15.851 16.7441 16.1774C16.4177 16.5038 16.0253 16.667 15.567 16.667H3.90033ZM3.90033 15.0003H15.567V10.0003H3.90033V15.0003ZM3.90033 8.33366H15.567V3.33366H3.90033V8.33366Z" />
  </svg>,
  "ExpandFirstLevelIcon"
);

export default ExpandFirstLevelIcon;
